export default "__VITE_ASSET__d749bc60__"